// Point d'entrée unique pour GSAP côté landing : enregistre les plugins une seule fois.
// @ts-ignore - typings GSAP
import { gsap } from 'gsap';
// @ts-ignore
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// @ts-ignore
import { ScrollSmoother } from 'gsap/ScrollSmoother';

if (typeof window !== 'undefined') {
  try {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GSAP plugins registration failed', e);
  }
}

export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const isTouchDevice = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(hover: none)').matches;

/**
 * Scroll vers un élément en passant par ScrollSmoother s'il est actif,
 * sinon fallback natif.
 */
export const scrollToElement = (target: string | HTMLElement, offset = 96) => {
  if (typeof window === 'undefined') return;
  const el = typeof target === 'string' ? document.getElementById(target) : target;
  if (!el) return;
  // @ts-ignore
  const smoother = ScrollSmoother.get?.();
  if (smoother) {
    smoother.scrollTo(el, true, `top ${offset}px`);
    return;
  }
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: 'smooth' });
};

export const refreshScroll = () => {
  try {
    // @ts-ignore
    ScrollTrigger.refresh();
  } catch (e) {
    /* noop */
  }
};

export { gsap, ScrollTrigger, ScrollSmoother };
